'use client';
import * as React from 'react';
import { Control, RegisterOptions, UseFormUnregister } from 'react-hook-form';
import RenderFormFieldComponent from './RenderFormFieldComponent';
import { FileProps } from '../DragAndDrop';

export type GroupTypes<T = any> = {
    [key: string]: {
        label?: React.ReactNode;
        columns: string;
        items: FormFieldGroup<T>[];
        description?: string
        icon?: React.ElementType,
    };
};

export type FormFieldGroup<T = any> = {
    id?: string;
    name: string | T;
    defaultValue?: string | number | boolean;
    noValidateDefaultValues?: boolean;
    disabled?: boolean;
    label?: string | React.ReactNode;
    placeholder?: string;
    messageByType?: {
        [key in keyof RegisterOptions]: any;
    };
    rules?: Omit<RegisterOptions<any, any>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>;
    type?: React.HTMLInputTypeAttribute | 'radio' | 'select' | 'textarea' | 'color' | 'file';
    options?: {
        label: string;
        value: any;
    }[];
    onChange?: (e: any) => void;
    oldValue?: any; 
    pattern?: RegExp;
    sub_item?: React.ReactNode;
    maxLength?: number;
    min?: number | string;
    max?: number;
    unit?: string;
    colorRange?: string;
    customErrorMessage?: string | React.ReactNode;
    classNameLabel?: string;
    classNameContent?: string;
    classNameInput?: string;
    isMulti?: boolean;
    buttonToggle?: React.ReactNode;
    classNameContentInput?: string;
    classContainer?: string;
    classMessageError?: string;
};

type Props = {
    baseObj?: {
        [key: string]: any;
    }; // obj to get default value from de object
    fields: FormFieldGroup[];
    control: Control<any> | undefined;
    purchases?: Date[];
    onSubmit?: () => void;
    unregister?: UseFormUnregister<any>;
    setFiles?: (files: File[]) => void;
    files?: File[];
    filesComponent?: FileProps[];
    setFilesComponent?: (files: FileProps[]) => void;
    deleteFile?: (file: FileProps) => void;
};

const RenderFormFieldsComponent = ({
    baseObj,
    fields,
    control,
    onSubmit,
    unregister,
    setFiles,
    files,
    filesComponent,
    setFilesComponent,
    deleteFile,
}: Props) => {
    return (
        <>
            {control &&
                fields &&
                fields.length > 0 &&
                fields.map((item, index) => {
                    return (
                        <RenderFormFieldComponent
                            item={item}
                            unregister={unregister}
                            key={item.name + '_' + index}
                            control={control}
                            baseObj={baseObj}
                            onSubmit={onSubmit}
                            setFiles={setFiles}
                            files={files}
                            filesComponent={filesComponent}
                            setFilesComponent={setFilesComponent}
                            deleteFile={deleteFile}
                        />
                    );
                })}
        </>
    );
};

export default RenderFormFieldsComponent;
